"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Router = exports.router = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _views = require("./views");

var _DevNavigation = require("./__dev/DevNavigation");

var _types = require("./types");

var _hooks = require("./hooks");

var _RouterScrollManager = require("./utils/RouterScrollManager");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getIs404 = function getIs404(pathname) {
  var validPaths = Object.values(_types.Routes).map(function (value) {
    return value;
  });
  return !validPaths.includes(pathname);
};

var getPageTitle = function getPageTitle(pathname) {
  if (!pathname || pathname === '/') {
    return 'index';
  }

  return pathname.substr(1);
};

var RouteHandlers = function RouteHandlers() {
  var trackEvent = (0, _hooks.useEventTracker)();

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  (0, _react.useEffect)(function () {
    var is404 = getIs404(pathname);

    if (is404) {
      var pageTitle = getPageTitle(pathname);
      trackEvent({
        action: 'poi-error',
        label: '404',
        location: pageTitle
      });
    }
  }, [pathname, trackEvent]);
  return /*#__PURE__*/_react.default.createElement(_RouterScrollManager.RouterScrollManager, null);
};

var router = [_types.Routes.init, _types.Routes.institutions, _types.Routes.login, _types.Routes.accounts, _types.Routes.income];
exports.router = router;

var Router = function Router() {
  var isConfigured = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.state.userToken && ctx.state.guid;
  });
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.MemoryRouter, {
    initialEntries: router,
    initialIndex: isConfigured ? 1 : 0
  }, undefined === 'local' && !undefined && /*#__PURE__*/_react.default.createElement(_DevNavigation.DevNavigation, {
    logAppState: false
  }), /*#__PURE__*/_react.default.createElement(RouteHandlers, null), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: _types.Routes.init
  }, /*#__PURE__*/_react.default.createElement(_views.Init, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: _types.Routes.institutions
  }, /*#__PURE__*/_react.default.createElement(_views.Institutions, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: _types.Routes.login
  }, /*#__PURE__*/_react.default.createElement(_views.Login, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: _types.Routes.mfa
  }, /*#__PURE__*/_react.default.createElement(_views.Mfa, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: _types.Routes.accounts
  }, /*#__PURE__*/_react.default.createElement(_views.Accounts, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: _types.Routes.income
  }, /*#__PURE__*/_react.default.createElement(_views.Income, null))));
};

exports.Router = Router;